document.addEventListener('DOMContentLoaded', () => {
    (function (d) {
        "use strict";
        var widgetScript = d.createElement("script");
        widgetScript.id = "unistats-widget-script";
        widgetScript.src = "https://discoveruni.gov.uk/widget/embed-script";
        var scriptTags = d.getElementsByTagName("script")[0];
        if (d.getElementById("unistats-widget-script")) {
            return;
        }
        scriptTags.parentNode.insertBefore(widgetScript, scriptTags);
    })(document);
});